import { Button } from 'react-bootstrap';
import { BsCheckLg } from 'react-icons/bs';
import { priceWithVat, VAT_RATE } from '../../config/plans';

const WASTE_FEATURE_LABELS = {
    maxBranches:        ['Prevádzka',           'Prevádzky',            'Prevádzok'],
    maxEvidenceLists:   ['Evidenčný list',       'Evidenčné listy',      'Evidenčných listov'],
    maxClients:         ['Klient',               'Klienti',              'Klientov'],
    maxWarehouses:      ['Sklad',                'Sklady',               'Skladov'],
    maxContainers:      ['Nádoba',               'Nádoby',               'Nádob'],
    maxConsents:        ['Súhlas',               'Súhlasy',              'Súhlasov'],
    maxOperationalLogs: ['Prevádzkový denník',   'Prevádzkové denníky',  'Prevádzkových denníkov'],
};

const PPWR_FEATURE_LABELS = {
    maxPackagingUnits: ['Obalová jednotka', 'Obalové jednotky', 'Obalových jednotiek'],
};

const formatValue = (val) => (val >= 9999 ? 'Neobmedzene' : val === 0 ? '—' : val);
const pluralize = (val, forms) => {
    if (val >= 9999) return forms[2];
    if (val === 1) return forms[0];
    if (val >= 2 && val <= 4) return forms[1];
    return forms[2];
};
const formatEur = (cents) => `${(cents / 100).toFixed(2).replace('.', ',')} €`;

const RENEWAL_DAYS_BEFORE = 30;

const PlanCard = ({ planKey, planData, currentPlan, subscriptionStatus, currentPeriodEnd, onUpgrade, module = 'waste', moduleActivated = false }) => {
    const isCurrentPlan = currentPlan === planKey;
    const isExpired = subscriptionStatus === 'canceled';
    const isFree = planData.price === 0;
    const featureLabels = module === 'ppwr' ? PPWR_FEATURE_LABELS : WASTE_FEATURE_LABELS;
    const isRecommended = module === 'ppwr' ? planKey === 'M' : planKey === 'start';
    const hasActivePlan = moduleActivated && currentPlan && !isExpired;
    const isHighlighted = hasActivePlan ? (isCurrentPlan && !isExpired) : isRecommended;

    const daysUntilExpiry = currentPeriodEnd
        ? Math.ceil((new Date(currentPeriodEnd) - new Date()) / (1000 * 60 * 60 * 24))
        : null;
    const canRenew = daysUntilExpiry !== null && daysUntilExpiry <= RENEWAL_DAYS_BEFORE;

    return (
        <div
            className="p-4 rounded h-100 d-flex flex-column"
            style={{
                backgroundColor: '#fff',
                border: isHighlighted ? '2px solid #0B1157' : '1px solid #EDF2F7',
                position: 'relative',
            }}
        >
            {isHighlighted && (
                <span
                    style={{
                        position: 'absolute',
                        top: '-12px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        backgroundColor: '#0B1157',
                        color: '#4DFFFF',
                        fontSize: '11px',
                        fontWeight: 700,
                        padding: '3px 14px',
                        borderRadius: '20px',
                        letterSpacing: '0.5px',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {isCurrentPlan && !isExpired ? 'AKTUÁLNY PLÁN' : 'ODPORÚČANÉ'}
                </span>
            )}

            <p style={{ color: '#718094', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 4px' }}>
                Plán
            </p>
            <h5 style={{ color: '#0B1157', fontWeight: 700, margin: '0 0 16px' }}>
                {planData.label}
            </h5>

            <div className="mb-4">
                {isFree ? (
                    <>
                        <span style={{ color: '#0B1157', fontSize: '28px', fontWeight: 700 }}>Zadarmo</span>
                        <div style={{ color: '#718094', fontSize: '13px', marginTop: '2px' }}>30 dní zadarmo</div>
                    </>
                ) : (
                    <>
                        <span style={{ color: '#0B1157', fontSize: '28px', fontWeight: 700 }}>
                            {formatEur(planData.price)}
                        </span>
                        <span style={{ color: '#718094', fontSize: '13px' }}> bez DPH / rok</span>
                        <div style={{ color: '#718094', fontSize: '12px', marginTop: '2px' }}>
                            {formatEur(priceWithVat(planData.price))} s DPH ({Math.round(VAT_RATE * 100)} %)
                        </div>
                    </>
                )}
            </div>

            {module === 'ppwr' && planData.features ? (
                <>
                    {planData.tagline && (
                        <p style={{ color: '#718094', fontSize: '12px', marginBottom: '12px', lineHeight: '1.5' }}>
                            {planData.tagline}
                        </p>
                    )}
                    <ul className="list-unstyled mb-4 flex-grow-1">
                        <li className="d-flex align-items-start mb-2" style={{ fontSize: '14px', color: '#4A5568' }}>
                            <BsCheckLg style={{ color: '#0B1157', marginRight: '10px', flexShrink: 0, marginTop: '2px' }} />
                            <span><strong>{formatValue(planData.maxPackagingUnits)}</strong> {pluralize(planData.maxPackagingUnits, PPWR_FEATURE_LABELS.maxPackagingUnits)}</span>
                        </li>
                        {planData.features.map((feature, i) => (
                            <li key={i} className="d-flex align-items-start mb-2" style={{ fontSize: '14px', color: '#4A5568' }}>
                                <BsCheckLg style={{ color: '#0B1157', marginRight: '10px', flexShrink: 0, marginTop: '2px' }} />
                                <span>{feature}</span>
                            </li>
                        ))}
                    </ul>
                </>
            ) : (
                <ul className="list-unstyled mb-4 flex-grow-1">
                    {Object.entries(featureLabels).map(([key, label]) => (
                        planData[key] !== undefined && planData[key] !== 0 ? (
                            <li key={key} className="d-flex align-items-center mb-2" style={{ fontSize: '14px', color: '#4A5568' }}>
                                <BsCheckLg style={{ color: '#0B1157', marginRight: '10px', flexShrink: 0 }} />
                                <span>
                                    <strong>{formatValue(planData[key])}</strong> {pluralize(planData[key], label)}
                                </span>
                            </li>
                        ) : null
                    ))}
                </ul>
            )}

            {isCurrentPlan && !isExpired ? (
                <div className="d-flex flex-column gap-2">
                    <Button
                        disabled
                        style={{
                            backgroundColor: '#F4F5FE',
                            border: 'none',
                            color: '#718094',
                            borderRadius: '12px',
                            padding: '10px',
                        }}
                    >
                        Aktuálny plán
                    </Button>
                    {canRenew && (
                        <Button
                            className="btn-custom-small"
                            onClick={() => onUpgrade(planKey)}
                        >
                            Predĺžiť o rok
                        </Button>
                    )}
                </div>
            ) : isFree ? (
                !moduleActivated && (
                    <Button
                        className="btn-custom-small"
                        onClick={() => onUpgrade(planKey)}
                    >
                        Aktivovať zadarmo
                    </Button>
                )
            ) : (
                <Button
                    className="btn-custom-small"
                    onClick={() => onUpgrade(planKey)}
                >
                    {isCurrentPlan && isExpired ? 'Obnoviť predplatné' : `Prejsť na ${planData.label}`}
                </Button>
            )}
        </div>
    );
};

export default PlanCard;
